import React from "react";
import { IconStar, IconShield } from "./Icons";

const Stars = ({ value = 5, max = 5 }) => (
  <span className="stars" aria-hidden="true">
    {Array.from({ length: max }).map((_, i) => (
      <IconStar key={i} filled={i < Math.round(value)} />
    ))}
  </span>
);

export const Booking = ({ data, reviews }) => {
  const airbnb = reviews?.airbnb;
  const booking = reviews?.booking;

  return (
    <section className="section section--sand" id="booking">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Reserve</span>
          <h2>Book your stay</h2>
          <hr className="rule" />
          <p>
            Whether it's a romantic escape or a family adventure, Casa Carmela is the perfect base
            for exploring Positano and the Amalfi Coast.
          </p>
        </div>

        <div className="booking__grid">
          <article className="booking-card booking-card--airbnb">
            <div className="booking-card__top">
              <span className="booking-card__brand">Airbnb</span>
              {airbnb?.score && (
                <span className="booking-card__score">
                  {Number(airbnb.score).toFixed(2)}
                  <small>/5</small>
                </span>
              )}
            </div>
            <div>
              <p className="booking-card__label">
                <strong>{airbnb?.label || "Guest favourite"}</strong>
                {airbnb?.count ? ` · ${airbnb.count} reviews` : ""}
              </p>
              {airbnb?.score && <Stars value={airbnb.score} />}
            </div>
            <a
              className="btn btn--accent btn--block"
              href={data?.airbnbLink || "https://www.airbnb.com/rooms/826055515812450770"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Check dates on Airbnb
            </a>
          </article>

          <article className="booking-card booking-card--booking">
            <div className="booking-card__top">
              <span className="booking-card__brand">Booking.com</span>
              {booking?.score && (
                <span className="booking-card__score">
                  {Number(booking.score).toFixed(1)}
                  <small>/10</small>
                </span>
              )}
            </div>
            <div>
              <p className="booking-card__label">
                <strong>{booking?.label || "Exceptional"}</strong>
                {booking?.count ? ` · ${booking.count} reviews` : ""}
              </p>
              {booking?.score && <Stars value={booking.score / 2} />}
            </div>
            <a
              className="btn btn--primary btn--block"
              href={data?.bookingLink || "https://www.booking.com/hotel/it/casa-carmela-positano.html"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Check dates on Booking.com
            </a>
          </article>
        </div>

        <p className="booking__note">
          <IconShield width={15} height={15} style={{ verticalAlign: "-2px", marginRight: 6 }} />
          Booking through either platform is protected by their guest guarantee. You can also{" "}
          <a href="#contact">write to us directly</a>.
        </p>
      </div>
    </section>
  );
};

export default Booking;
